// extracted by mini-css-extract-plugin
export default {"classesContainer":"EnrolledClasses_classesContainer__RQmy6","classesHeader":"EnrolledClasses_classesHeader__fzQND"};